<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <validation-provider
          :vid="uuid()"
          name="Project Name"
          rules="required"
          v-slot="v"
        >
          <v-text-field
            label="Project Name (required)"
            v-model="project.projectName"
            @input="updateProject"
          ></v-text-field>
          <span class="validation-message">{{ v.errors[0] }}</span>
        </validation-provider>
      </v-col>

      <v-col cols="6">
        <v-text-field
          label="Project Version (optional)"
          v-model="project.projectVersion"
          @input="updateProject"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <validation-provider
          :vid="uuid()"
          name="Product Name"
          rules="required"
          v-slot="v"
        >
          <v-text-field
            label="Product Name (required)"
            v-model="project.productName"
            @input="updateProject"
          ></v-text-field>
          <span class="validation-message">{{ v.errors[0] }}</span>
        </validation-provider>
      </v-col>

      <v-col cols="6">
        <validation-provider
          :vid="uuid()"
          name="Product Version"
          rules="required"
          v-slot="v"
        >
          <v-text-field
            label="Product Verison (optional)"
            v-model="project.productVersion"
            @input="updateProject"
          ></v-text-field>
          <span class="validation-message">{{ v.errors[0] }}</span>
        </validation-provider>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <v-text-field
          label="Product Release (optional)"
          v-model="project.productRelease"
          @input="updateProject"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import uuid from "src/mixins/uuid";

export default {
  name: "Project",
  components: { ValidationProvider },
  mixins: [uuid],
  computed: {
    project() {
      return this.$store.state.projectProperties.project;
    },
  },
  methods: {
    updateProject() {
      this.$store.dispatch("updateProjectProperties", {
        project: this.project,
      });
    },
  },
};
</script>
